import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { z } from 'zod';

export function useOpenCallerSms(
  conversationId: string,
  onOpen: (id: string) => void
) {
  const client = useQueryClient();
  const mutation = useMutation({
    mutationFn: () =>
      apiClient.post(
        `voice-receptionist/conversations/${conversationId}/sms`,
        {},
        { schema: z.object({ conversationId: z.string() }) }
      ),
    onSuccess: (data) => {
      void client.invalidateQueries({
        queryKey: queryKeys.voiceReceptionist.calls(conversationId),
      });
      void client.invalidateQueries({
        queryKey: queryKeys.conversations.all(),
      });
      onOpen(data.conversationId);
    },
    onError: (error: Error) =>
      toast.error(error.message || 'Could not open the text thread'),
  });
  return { openSms: mutation.mutate, isOpening: mutation.isPending };
}
